module.exports = __webpack_public_path__ + "media/customizations/paintedtree/back-43609f6171c4e060bd0df9fa06e80f28.jpg";